import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { string, shape, arrayOf, bool } = proptypes;

export const TooltipContent = (
  {
    hoveredCombinationDetails: {
      image,
      combinationDetails = [],
      pricing,
    } = {},
    oosTooltipMessage = '',
  }
) => {
  const {
    message,
    shouldHidePriceForMap,
    isSpecialPrice,
    strikeThroughPriceForMap,
    price,
    unitValue,
    UOM,
    caseUOM
  } = pricing || {};

  let { formatted } = price || {};
  if (unitValue && caseUOM && caseUOM === 'sq. ft.') {
    formatted = `$${unitValue.toFixed(2)} /${caseUOM} (${formatted} /${UOM})`;
  }
  return (
    <div className="sui-flex sui-flex-col sui-items-center">
      <span>
        <img
          src={image}
          alt="swatch"
          width="100"
          height="auto"
        />
      </span>
      {(combinationDetails || []).map((attribute, attributeIndex) => {
        const attributeLabel = attribute.shouldDisplayAttributeLabel && `${attribute.attributeLabel}:`;
        const attributeLabelValue = attribute.attributeValue && attribute.attributeValue.split(',')[0];
        return (
          <div
            key={`${attributeLabelValue}-${attributeIndex}`}
          >
            <Typography variant="body-base">{attributeLabel} {attributeLabelValue}</Typography>
          </div>
        );
      })}
      {(formatted || message)
        && (
          <>
            {(formatted && !shouldHidePriceForMap) && (
              <>
                <Typography
                  variant="body-base"
                  weight="bold"
                  color={isSpecialPrice && 'success'}
                  decoration={strikeThroughPriceForMap && 'line-through'}
                >
                  {formatted}
                </Typography>
              </>
            )}
            {message && (
              <Typography variant="body-xs">{message}</Typography>
            )}
          </>
        )}
      {
        oosTooltipMessage
        && <Typography variant="body-base" align="center" weight="bold">{oosTooltipMessage}</Typography>
      }
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';

TooltipContent.propTypes = {
  hoveredCombinationDetails: shape({
    image: string,
    combinationDetails: arrayOf(shape({
      attributeLabel: string,
      attributeValue: string,
      shouldDisplayAttributeLabel: bool
    })),
    pricing: shape({
      message: string,
      price: shape({
        formatted: string,
      })
    })
  }).isRequired,
  oosTooltipMessage: string,
};